import { css } from "@emotion/react"
import { Icon } from "source/shared/components/Icon"

const ICON_SIZE_RATIO = 0.3

export default function EpisodeArtworkFallback({
  size,
  borderRadius,
}: {
  size: number
  borderRadius: number
}) {
  const iconSize = Math.round(size * ICON_SIZE_RATIO)

  return (
    <div
      aria-hidden="true"
      css={css`
        width: ${size}px;
        height: ${size}px;
        border-radius: ${borderRadius}px;
        background-color: var(--d-fill-color-neutral-070);
        border: 1px solid var(--d-fill-color-neutral-060);
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: center;
      `}
    >
      <Icon
        symbol="general#podcast"
        css={css`
          color: var(--d-fill-color-neutral-030);
          width: ${iconSize}px;
          height: ${iconSize}px;
        `}
      />
    </div>
  )
}
